/* eslint-disable @typescript-eslint/naming-convention */
import { BaseModel } from '../../../../core/abstractions/base.model';

export class AddressModel extends BaseModel {
    street = '';
    streetNumber = '';
    streetSupplement = '';
    streetAfterSupplement = false;
    isPoBox = false;
    poBox = '';
    locationZipCode = '';
    locationCity = '';
    countryId = '';
    locationId = '';

    constructor(init?: Partial<AddressModel>) {
        super();
        Object.assign(this, init);
    }
}
